import { CheckCircle2, Clock3, AlertTriangle } from "lucide-react";

import { useAppSelector } from "@/store/hooks";
import type { BlockchainNetwork } from "@/interfaces/blockchainNetwork";
import type { TransactionQuote } from "@/interfaces/transaction";
import { formatAmount } from "@/utils/formatAmount";

interface WithdrawalQuote {
  amount: number;
  networkFee: number;
  processingFee: number;
  totalFee: number;
  receiveAmount: number;
  estimatedArrival?: string;
  minimumAmount?: number;
  maximumAmount?: number;
}

interface Props {
  networks: BlockchainNetwork[];
  value?: BlockchainNetwork;
  onChange: (network: BlockchainNetwork) => void;
  disabled?: boolean;
  quote?: NoInfer<TransactionQuote> | undefined;
}

const WithdrawNetworkSelector = ({
  networks,
  value,
  onChange,
  disabled = false,
  quote,
}: Props) => {
  const { theme } = useAppSelector((state) => state.ui);

  console.log(" QUOTE", quote);

  return (
    <div className="space-y-3">
      <label className="text-sm text-muted-foreground">
        Blockchain Network
      </label>

      <div className="space-y-3">
        {networks.map((network) => {
          const unavailable = !network.enabled || !network.withdrawEnabled;

          const selected = value?.id === network.id;

          return (
            <button
              key={network.id}
              type="button"
              disabled={disabled || unavailable}
              onClick={() => onChange(network)}
              className={`w-full rounded-xl border p-4 text-left transition-all ${
                selected
                  ? "border-primary bg-primary/10"
                  : theme === "dark"
                    ? "border-border bg-card hover:bg-muted"
                    : "border-gray-200 bg-white hover:bg-gray-50"
              } ${unavailable ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              <div className="flex justify-between items-start">
                <div>
                  <h4 className="font-medium">{network.name}</h4>

                  <p className="text-xs text-muted-foreground mt-1">
                    {/* {network.chainType} */}
                  </p>
                </div>

                {selected && <CheckCircle2 className="w-5 h-5 text-primary" />}
              </div>

              <div className="mt-4 flex flex-wrap gap-4 text-xs">
                <div className="flex items-center gap-1">
                  <Clock3 className="w-4 h-4" />

                  <span>~2 min</span>
                  {/* <span>~{network.estimatedMinutes ?? "-"} min</span> */}
                </div>

                <div>
                  Fee:
                  <strong className="ml-1">
                    {value?.id === network.id && quote
                      ? `${formatAmount({
                          amount: quote.fee.feeAmount,
                          isFiat: quote?.fee?.feeCurrency?.isFiat,
                          decimals: quote?.fee?.feeCurrency?.decimals,
                        })} ${quote?.fee?.feeCurrency?.symbol}`
                      : "--"}
                  </strong>
                </div>
              </div>

              {unavailable && (
                <div className="mt-3 flex items-center gap-2 text-yellow-500">
                  <AlertTriangle className="w-4 h-4" />

                  <span className="text-xs">
                    Withdrawals unavailable on this network.
                  </span>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default WithdrawNetworkSelector;
